<template>
  <section class="mainText ">
    <b-container fluid="xl">
        <b-row id="main1" class="maintText__row">
            <b-col cols="12" class="pb-5 side-gap">
                <h2 style="mainText__mainName--maintxtx">
                    Online bántalmazás 
                </h2>
                <p class="hashText">– A szavak is tudnak ütni</p>
            </b-col>
        </b-row>
        <b-row class="maintText__row">
            <b-col cols="12" lg="6">
            <div class="maintText__txt-content pb-lg-5 pb-2">
                <p class="text">
                Amikor azt mondjuk, hogy valakit bántanak, legtöbben még mindig a klasszikus zaklatásra gondolnak: verekedés, lökdösődés, vagy nyílt megalázás. Pedig a mai világban az egyik legelterjedtebb formája az agressziónak már nem a való életben történik, hanem a kijelzők mögött. És pont ettől lesz olyan alattomos.</p>

                <p class="text">
                Az online bántalmazás – vagyis a cyberbullying – nem mindig hangos. Nem mindig feltűnő. Néha „csak” egy beszólás egy kommentben, egy megalázó mém, egy direkt elkerülő reakció, vagy egy üzenet, amitől rosszul alszol. És az igazán ijesztő része az, hogy sokan nem is veszik elég komolyan. Mintha az, hogy az interneten történik, kevésbé lenne valódi. Pedig nagyon is az.
                </p>

                <p class="text">
                Amikor valakit digitálisan bántanak, a fájdalom nem kevesebb – csak láthatatlanabb. És mivel a közösségi média sokszor az önkifejezés terepe, különösen nehéz, ha valakit pont ezen a felületen ér támadás. Egy rossz komment nemcsak az adott posztra hat, hanem az önértékelésedre, a kedvedre, és akár az egész napodra is.</p>

                <p class="text">
                És mindez sajnos nem ritka jelenség. Egy 2023-as kutatás szerint a 13–18 éves magyar fiatalok 46%-a tapasztalt már online bántalmazást. Minden ötödik középiskolás rendszeresen kap sértő vagy megalázó üzeneteket a közösségi médiában. Ráadásul a legtöbben – a megkérdezettek kétharmada – nem kér segítséget, ha ilyen történik velük, gyakran azért, mert attól tartanak, hogy úgysem változna semmi. És közben a gyerekek szerint a felnőttek – tanárok, szülők – nincsenek igazán felkészülve az online tér kihívásaira.</p>
                <p class="text">
                A bántók gyakran azt mondják: „csak vicc volt”, vagy „ne vedd ennyire a szívedre”. De a határ a poén és a megalázás között vékony, és nem a bántó dolga eldönteni, hogy átlépte-e. Hanem azé, akit érint. Épp ezért fontos, hogy ne nézzük el ezeket a helyzeteket. Ha látod, hogy valakit bántanak, szólj. Ha téged érint, beszélj róla, ne maradj egyedül vele. És ha valaha bántottál valakit, gondold végig, mit jelentett volna neked, ha ugyanezt visszakapod.</p>
                <p class="text">
                Az online világ része lett az életünknek – ezért ugyanúgy felelősséggel kell benne jelen lenni, mint a valóságban. Mert lehet, hogy egy profil mögé rejtőzünk, de amit mondunk, írunk, kommentelünk – az valódi emberekhez ér el. <br>Június 20-án, az Anti-Cyberbullying Világnapon, ne csak olvasd ezt el – gondold végig, mit tehetsz ma azért, hogy valaki ne érezze magát egyedül.</p>
            </div>
            </b-col>
            <b-col cols="12" lg="6" class="order-4 order-lg-1">
              <img src="images/36.jpg" class="w-100 margin-top-sm-44 mb-4"/>
          </b-col>
        </b-row>
    </b-container>
    <Articles :isFirst="true"/>
  </section>
</template>
<script>
import Articles from '../components/Articles.vue'

export default {
  components: {
    Articles
  },
  mounted(){

    this.setMetaTags({        
        title: "Online bántalmazás – A szavak is tudnak ütni", 
        desc: "Amikor azt mondjuk, hogy valakit bántanak, legtöbben még mindig a klasszikus zaklatásra gondolnak: verekedés, lökdösődés, vagy nyílt megalázás.", 
        keywords: null, 
        ogType: 'website', 
        ogTitle: "Online bántalmazás – A szavak is tudnak ütni",
        ogImage: null, 
        ogImageWidth: null, 
        ogImageHeight: null, 
        ogDesc: "Amikor azt mondjuk, hogy valakit bántanak, legtöbben még mindig a klasszikus zaklatásra gondolnak: verekedés, lökdösődés, vagy nyílt megalázás."        
    })
  }
}
</script>